import React, { useState, useRef } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import axios from "axios";
import { BASE_URL, security_key } from "../../../global";
import { useFormik } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import Select from "react-select";

const AddMagazine = ({ fetchAllMagazine }) => {
    const history = useNavigate();
    const [showPreview, setShowPreview] = useState(false);
    const [imagePreview, setImagePreview] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const formRef = useRef(null);
    const [magTypeOption, setMagTypeOption] = useState([
        { value: 2, label: "Manual" },
        { value: 3, label: "Feed" },
    ]);

    const resetFormFields = (resetForm, setValues, initialValues) => {
        resetForm();
        setValues({
            ...initialValues,
        });
    };

    const initialValues = {
        mag_name: "",
        mag_link: "",
        mag_img: null,
        mag_type: "",
        fk_user_key: sessionStorage.getItem("pk_user_key"),
        created_by: sessionStorage.getItem("pk_user_key"),
    };

    const basicSchema = Yup.object().shape({
        mag_name: Yup.string()
            .required("Magazine Name is required.")
            .min(3, "Magazine Name must be at least 3 characters.")
            .max(100, "Magazine Name must be at most 100 characters.")
            // .matches(/^[a-zA-Z\s]*$/, "Special characters are not allowed.")
            .matches(/^[^\s].*[^\s]$/, "No leading or trailing spaces are allowed.")
            .test("unique-link", "Magazine Name is already existing in the database", async function (value) {
                if (!value) return true;
                return await checkMagazineName(value);
            }),
        mag_link: Yup.string().url("Invalid URL format.").required("Magazine Link is required."),
        mag_type: Yup.string().required("Magazine type is required."),
        mag_img: Yup.mixed()
            .required("Magazine Image is required.")
            .test("fileType", "Unsupported File Format", (value) => {
                const supportedFormats = ["image/jpeg", "image/png", "image/gif"];
                return value ? supportedFormats.includes(value.type) : false;
            })
            .test("fileSize", "File size must be less than 2MB", (value) => {
                const maxSize = 2 * 1024 * 1024; // 2MB in bytes
                return value ? value.size <= maxSize : false;
            }),
    });

    async function checkMagazineName(mag_name) {
        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "checkMagazineName",
            mag_name: mag_name,
        });

        const output = response.data;

        return output == 1 ? false : true;
    }

    const formik = useFormik({
        initialValues,
        validationSchema: basicSchema,
        enableReinitialize: true,
        onSubmit: async (formValues) => {
            toast.dismiss();

            setIsSubmitting(true);

            const response = await axios.post(
                BASE_URL + "API/apicall",
                {
                    security_key: security_key,
                    mode: "addMagazine",
                    ...formValues,
                },
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            const output = response.data;
            if (output == 1) {
                toast.success("Added successfully!");
                setTimeout(() => history("/admin/magazine-management"), 3000);
            } else {
                toast.error("Oops! Something went wrong.", {
                    autoClose: 3000,
                });
            }
            setTimeout(function () {
                setIsSubmitting(false);
            }, 3000);
        },
    });

    const { values, handleChange, handleBlur, touched, errors, handleSubmit, setFieldValue, setTouched, resetForm, setValues } = formik;

    const handleFileChange = (event) => {
        const file = event.currentTarget.files[0];
        setFieldValue("mag_img", file);
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => setImagePreview(reader.result);
            reader.readAsDataURL(file);
        } else {
            setImagePreview(null);
        }
    };
    const handleFileClick = () => {
        setFieldValue("mag_img", null);
        setImagePreview(null);
    };

    const handlePreview = () => {
        setShowPreview(true);
    };

    const handleClosePreview = () => {
        setShowPreview(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();

        const files = e.dataTransfer ? e.dataTransfer.files : null;

        if (files && files[0]) {
            const file = files[0];

            setFieldValue("mag_img", file);

            // Preview the image
            const reader = new FileReader();
            reader.onloadend = () => setImagePreview(reader.result);
            reader.readAsDataURL(file);

            // document.getElementById("fileInput").value = "";
            if (document.getElementById("fileInput")) {
                document.getElementById("fileInput").value = null; // Reset file input correctly
            }
        } else {
            console.error("No files were dropped.");
        }
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    return (
        <div className="container mt-4 bg-white p-4 mb-3">
            <ToastContainer position="top-center" />
            <Form className="mb-3" onSubmit={handleSubmit}>
                <Form.Group className="d-flex justify-content-between mb-3">
                    <h4 className="mb-2">Add New Magazine</h4>
                    <div>
                        <Button variant="dark" type="submit" ref={formRef} disabled={isSubmitting}>
                            Add Magazine
                        </Button>
                    </div>
                </Form.Group>
                <Form.Group className="w-100 mb-3">
                    <Form.Label>
                        Magazine Type <span className="text-danger">*</span>
                    </Form.Label>
                    <Select
                        options={magTypeOption}
                        id="mag_type"
                        name="mag_type"
                        value={magTypeOption.find((option) => option.value && values.mag_type && option.value.toString() === values.mag_type.toString())}
                        onChange={(selectedOption) => {
                            const event = {
                                target: {
                                    name: "mag_type",
                                    value: selectedOption["value"],
                                },
                            };
                            handleChange(event);
                        }}
                        onBlur={(event) => {
                            handleBlur(event);
                            setTouched({ ...touched, mag_type: true });
                        }}
                    />

                    {errors.mag_type && touched.mag_type && <p className="text-danger">{errors.mag_type}</p>}
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label>
                        Magazine Title <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                        type="text"
                        name="mag_name"
                        value={values.mag_name}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="Enter magazine Name"
                    />
                    {errors.mag_name && touched.mag_name && <p className="text-danger">{errors.mag_name}</p>}
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label>
                        Magazine Link <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                        type="text"
                        name="mag_link"
                        value={values.mag_link}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="Enter magazine link"
                    />
                    {errors.mag_link && touched.mag_link && <p className="text-danger">{errors.mag_link}</p>}
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label>
                        Magazine Logo <span className="text-danger">*</span>
                    </Form.Label>
                    <div
                        className="dropzone border p-4 rounded"
                        style={{ cursor: "pointer", textAlign: "center" }}
                        onClick={() => document.getElementById("fileInput").click()}
                        onDrop={handleDrop}
                        onDragOver={handleDragOver}
                    >
                        <Form.Control
                            id="fileInput"
                            type="file"
                            name="mag_img"
                            onChange={handleFileChange}
                            onClick={handleFileClick}
                            onBlur={handleBlur}
                            accept="image/*"
                            style={{ display: "none" }}
                        />

                        <div style={{ cursor: "pointer" }}>
                            <p>Drag 'n' drop an image, or click to select one</p>
                            {imagePreview && (
                                <img
                                    src={imagePreview}
                                    alt="Preview"
                                    style={{
                                        maxWidth: "100%",
                                        maxHeight: "200px",
                                        objectFit: "contain",
                                    }}
                                />
                            )}
                        </div>
                    </div>
                    {errors.mag_img && touched.mag_img && <p className="text-danger">{errors.mag_img}</p>}
                </Form.Group>
            </Form>

            {/* Preview Modal */}
            <Modal show={showPreview} onHide={handlePreview} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Magazine Preview</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h1>{values.mag_name}</h1>
                    <h4>{values.mag_link}</h4>
                    {imagePreview && <img src={imagePreview} alt="Preview" style={{ maxWidth: "100%", maxHeight: "200px", objectFit: "contain" }} />}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClosePreview}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default AddMagazine;
